import axios from '@/axios'
import authApi from '@/api/auth'
import { getCookie, setCookie, eraseCookie } from '@/cookies-helper'

const state = {
  isAuthenticated: false,
  user: {}
}

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  user: state => state.user
}

const mutations = {
  SET_AUTHENTICATED: (state, isAuthenticated) => {
    state.isAuthenticated = isAuthenticated
  },
  SET_USER: (state, user) => {
    state.user = user
  }
}

const actions = {
  setAuthenticated({ commit }, payload) {
    commit('SET_AUTHENTICATED', payload)
  },
  login({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      authApi
        .login(payload)
        .then(response => {
          commit('SET_AUTHENTICATED', true)
          let date = new Date()
          date.setDate(date.getDate() + 30)
          setCookie('token', response.token, date)
          return dispatch('getUser').then(() => {
            return resolve({ verified: response.verified })
          })
        })
        .catch(err => {
          return reject(err)
        })
    })
  },
  getUser({ commit }) {
    return new Promise((resolve, reject) => {
      authApi
        .getCurrentUser()
        .then(response => {
          commit('SET_USER', response)
          return resolve(response)
        })
        .catch(err => {
          return reject(err)
        })
    })
  },
  isAuthenticated({ dispatch, commit, state }) {
    if (state.isAuthenticated && state.user && state.user.id) {
      return true
    }

    let token = getCookie('token')
    if (token) {
      axios.defaults.headers.common.authorization = `JWT ${token}` || ''
      return dispatch('getUser').then(() => {
        commit('SET_AUTHENTICATED', true)
        return true
      })
    } else {
      return false
    }
  },
  isVerified({ state }) {
    return state.user && state.user.verified
  },
  refreshToken({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      authApi
        .refreshToken()
        .then(response => {
          let date = new Date()
          date.setDate(date.getDate() + 30)
          setCookie('token', response.token, date)
          dispatch('getUser').then(() => {
            return resolve()
          })
        })
        .catch(err => {
          return reject(err)
        })
    })
  },
  logout({ commit }) {
    commit('SET_AUTHENTICATED', false)
    commit('SET_USER', null)
    eraseCookie('token')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
